import { Clipboard } from '@angular/cdk/clipboard';
import { DatePipe } from '@angular/common';
import { Component, ElementRef, ViewChild, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ALERT_TYPE, CUSTOMER_DOCUSEAL_TYPE } from 'src/app/constants';
import { DocusealHistoryComponent } from 'src/app/Others/docuseal-history/docuseal-history.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Company } from 'src/model/company.model';
import { Customer } from 'src/model/customer.model';
import { Docuseal } from 'src/model/formJ.model';
import { CompanyService } from 'src/services/company.service';
import { CustomerService } from 'src/services/customer.service';
import { DocusealService } from 'src/services/docuseal.service';

@Component({
	selector: 'app-epf-settlement-breakdown-letter',
	templateUrl: './epf-settlement-breakdown-letter.component.html',
	styleUrl: './epf-settlement-breakdown-letter.component.scss',
	standalone: false,
	providers: [DatePipe]
})
export class EpfSettlementBreakdownLetterComponent implements OnInit {
	private activatedRoute = inject(ActivatedRoute);
	protected sharedService = inject(SharedService);
	private router = inject(Router);
	private customerService = inject(CustomerService);
	private companyService = inject(CompanyService);
	private docusealService = inject(DocusealService);
	private datepipe = inject(DatePipe);
	private clipboard = inject(Clipboard);

	selectedCompany: Company;
	selectedCustomer: Customer;
	selectedCustomerID: number;
	selectedCompanyID: number;

	loanAmount: number;
	@ViewChild('htmlData') htmlData: ElementRef;

	routeSubscription: any;
	settlement: number;
	simpan: number;
	latestDate: Date;
	printDate: Date;
	ref: string;
	signLink: string;
	dsList: Docuseal[] = new Array();

	constructor() {
		this.routeSubscription = this.activatedRoute.paramMap.subscribe(params => {
			this.selectedCustomerID = +params.get('customerId');
			this.selectedCompanyID = +params.get('companyId');

			this.settlement = this.sharedService.roundTo2Dec(this.router.getCurrentNavigation().extras.state.settlement);
			this.simpan = this.router.getCurrentNavigation().extras.state.simpan;
			this.latestDate = this.router.getCurrentNavigation().extras.state.latestDate;
			this.printDate = new Date();
		});
	}

	async ngOnInit(): Promise<void> {
		this.getCompanyInfo();
		this.getCustomerInfo();
		this.dsList = await this.docusealService.getCustomerDocuseals(this.selectedCustomerID, CUSTOMER_DOCUSEAL_TYPE.SETTLEMENT_BREAKDOWN);
	}

	getLatestSettlementDate() {
		//latest settlement date = 3 days after epf date
		const epfDate = new Date(this.selectedCustomer.EPFDate);
		return new Date(epfDate.getFullYear(), epfDate.getMonth(), epfDate.getDate() + 3);
	}

	async getCompanyInfo() {
		this.selectedCompany = await this.companyService.getCompanyDetails(this.selectedCompanyID);
	}

	async getCustomerInfo() {
		this.selectedCustomer = await this.customerService.getCustomerDetails(this.selectedCustomerID);
	}

	calculateBalance() {
		if (this.settlement != undefined && this.loanAmount != undefined && this.simpan != undefined) return this.settlement + this.loanAmount - this.simpan;
		else return 0;
	}

	print() {
		window.print();
	}

	async createSignLink() {
		let data = {
			referenceNumber: this.ref,
			oldBalance: this.settlement,
			oldBalanceDate: this.datepipe.transform(this.latestDate, 'dd/MM/yyyy'),
			previousPayment: this.simpan,
			amount: this.loanAmount,
			paymentDeadline: this.datepipe.transform(this.getLatestSettlementDate(), 'dd/MM/yyyy')
		};
		let ds = await this.docusealService.getPostSettlementBreakdownDocuseal(this.selectedCustomerID, data);
		if (ds) {
			this.signLink = ds.link;
		}
	}

	copySignLink(link: string) {
		this.clipboard.copy(link);
		this.sharedService.openAlert(`Copied the settlement breakdown sign link, please send the link to customer!`, ALERT_TYPE.SUCCESS);
	}

	async openViewDocusealHistory() {
		const modalRef = this.sharedService.openModal(DocusealHistoryComponent);
		modalRef.componentInstance.dsList = this.dsList;
	}
}
